import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';

import { FormField } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/FormField';
import {
  useCheckForwardAccumulatorByTradeCapture,
  useForwardAccumulatorSelector,
  useForwardAccumulatorTileId,
} from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { SgNumberInput } from '@/components/sg-design-system/components/input/SgNumberInput';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import {
  selectForwardAccumulatorProperty,
  selectForwardAccumulatorRfsSpotHedge,
  selectForwardAccumulatorValidation,
} from '@/store/forwardAccumulator/selectors.ts';
import { useAppSelector } from '@/store/hooks.ts';

export function SpotRef() {
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const tileId = useForwardAccumulatorTileId();
  const check = useCheckForwardAccumulatorByTradeCapture();

  const hedgeSpot = useAppSelector((state) => selectForwardAccumulatorProperty(state, tileId, 'spotHedge'));
  const rfsHedgeSpot = useForwardAccumulatorSelector((accumulator) =>
    selectForwardAccumulatorRfsSpotHedge(accumulator),
  );

  const validation = useAppSelector((state) => selectForwardAccumulatorValidation(state, tileId));

  const isPinned = isDefined(hedgeSpot);

  const rfsSpotHedgeValue = isDefined(rfsHedgeSpot) ? Number(rfsHedgeSpot) : undefined;

  const appliedSpotHedge = isDefined(hedgeSpot) ? Number(hedgeSpot) : rfsSpotHedgeValue;

  function handleChange(spotHedge: number | undefined | null) {
    sgwtWebAnalytics?.trackEvent(
      'ForwardAccumulator',
      'SpotForward ref change',
      isDefined(spotHedge) ? String(spotHedge) : 'cleared',
    );

    return check({ spotHedge });
  }

  return (
    <FormField formattedMessageId="forwardAccumulator.form.SpotRef">
      <div className="d-flex px-1">
        <TradeCaptureValidationWrapper validation={validation?.spotHedge}>
          <SgNumberInput
            valuePosition="start"
            size="sm"
            onChange={handleChange}
            className={isPinned ? 'text-info fw-bold ' : undefined}
            data-e2e="spotRef"
            acceleratorsEnabled
            value={appliedSpotHedge}
          />
        </TradeCaptureValidationWrapper>
        {isPinned && (
          <button
            onClick={() => handleChange(null)}
            type="button"
            className="btn btn-sm btn-icon btn-flat-primary"
            data-e2e="spotRef-pin"
          >
            <em className="icon icon-sm cursor-default line-height-1 text-secondary">push_pin</em>
          </button>
        )}
      </div>
    </FormField>
  );
}
